
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getDateRange } from "@/utils/dateRangeUtils";

export const useAnalyticsChart = (selectedDateRange: string) => {
  const dateRange = getDateRange(selectedDateRange);

  return useQuery({
    queryKey: ['analytics-chart', selectedDateRange],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('search_analytics')
        .select('created_at, interaction_type')
        .gte('created_at', dateRange.start)
        .lte('created_at', dateRange.end)
        .order('created_at');
      
      if (error) throw error;
      
      // Group by hour for today/yesterday, by day for longer periods
      const isShortPeriod = ['today', 'yesterday'].includes(selectedDateRange);
      const groupedStats: Record<string, { period: string; searches: number; clicks: number; views: number }> = {};
      
      data.forEach(item => {
        const date = new Date(item.created_at);
        const period = isShortPeriod 
          ? `${date.getHours()}:00`
          : date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
        
        if (!groupedStats[period]) {
          groupedStats[period] = { period, searches: 0, clicks: 0, views: 0 };
        }
        groupedStats[period][item.interaction_type === 'search' ? 'searches' : 
                           item.interaction_type === 'click' ? 'clicks' : 'views']++;
      });
      
      return Object.values(groupedStats);
    },
    refetchInterval: selectedDateRange === 'today' ? 60000 : undefined
  });
};
